import LocationPinSvg from '@assets/images/svg/location-pin.svg';
import React from 'react';
import { View } from 'react-native';

export interface LocationPinIconProps {
    size?: number;
    color?: string;
}

export function LocationPinIcon({ size = 14, color = '#808080' }: Readonly<LocationPinIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <LocationPinSvg width={size} height={size} color={color} />
        </View>
    );
}

export default LocationPinIcon;
